import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DatiPagamento } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';

@Component({
  selector: 'app-info-dato-pagamento',
  templateUrl: './info-dato-pagamento.component.html',
  styleUrls: ['./info-dato-pagamento.component.css']
})
export class InfoDatoPagamentoComponent implements OnInit {

  @Input() dP: DatiPagamento | undefined;

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  configProps : ConfigProps | undefined;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private configService: ConfigServiceService) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    this.configProps!.list.listDivisa.forEach(e => {
      e.label = e.val + " - " + e.label;
    });
    this.configProps!.list.listCausalePagamento.forEach(o => {
      if(o.text!.length > 150){
        o.text = o.text?.substr(0, 150) + "...";
      }
    })
  }


  close(){
    this.activeModal.close(null);
  }

  public save(){
      this.activeModal.close(this.dP!);
  }

}
